(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-wardrobe"]) return;
  try {
    
function initializeWardrobes() {
  document.querySelectorAll('.fc-wardrobe').forEach(function (wardrobe) {
    const input = wardrobe.querySelector('[data-wardrobe-search]');
    if (!input || input.dataset.ready) return;
    input.dataset.ready = 'true';
    const cards = wardrobe.querySelectorAll('[data-wardrobe-card]');
    const empty = wardrobe.querySelector('[data-wardrobe-no-results]');
    input.addEventListener('input', function () {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach(function (card) {
        const matches = (card.dataset.search || '').toLocaleLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      empty.hidden = visible !== 0;
    });
  });
}
initializeWardrobes();
document.addEventListener('shopify:section:load', initializeWardrobes);

  } catch(e) { console.error(e); }
})();
})();
